import { useEffect } from "react";
import { useSearchParam } from "react-use";
import instance from "../../util/axios";
          
import {Toast } from "antd-mobile-v5";

export default function AuthLoading() {
  const corpId = useSearchParam("corpId");
  const type = useSearchParam("type");
  const code = useSearchParam("code");

  useEffect(() => {
    if(code){
      const respNavs: any = instance
      .post(`/wework/sp/user/loginByWeWorkCodeNoCorpId`, {
        code: code,
      })
      .then(async (resp) => {
        if (resp.data.Status == 1) {
          Toast.show(`授权成功`);
          window.location.href="https://crm.tysoft.com/home";
            // window.location.href="http://localhost:3000/home";
        } else {
          if (resp.data.Data) {
            Toast.show(resp.data.Data)
          } else {
            Toast.show("授权失败")
          }
        }
      });
    }else{
    if(corpId){
      instance
      .post(`/wework/sp/user/getWeWorkInfoByCorpId`, { corpId: corpId })
      .then((resp) => {
        if (resp.data.Status === "1") {
          const data = resp.data.Data;
          const url =
            type === "customerDetail"
              ? `https://mobile.react.tysoft.com/chat/customer/detail?corpId=${corpId}&form=wx`
              : type === "material"
              ? `https://mobile.react.tysoft.com/material?corpId=${corpId}`
              : type === "customersAndGroups"
              ? `https://mobile.react.tysoft.com/CustomersAndGroups/1?corpId=${corpId}`
              : "";
          // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
          //   data.agentId
          // }&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=${
          //   data.sourceAgentid
          // }#wechat_redirect`;
          // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww810695a1bfb56237&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_privateinfo&state=STATE#wechat_redirect`;
          console.log(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.corpId}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_privateinfo&state=&agentid=${data.agentid}#wechat_redirect`)
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.corpId}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_privateinfo&state=&agentid=${data.agentid}#wechat_redirect`;
          //https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww810695a1bfb56237
          //&redirect_uri=https://mobile.react.tysoft.com/MaterialSendPage?staffId=2
          //&corpId=5360&uuid=1&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=1000009#wechat_redirect
        }
      });
    }else{
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww810695a1bfb56237&redirect_uri=${encodeURIComponent("https://mobile.react.tysoft.com/wework/loading")}&response_type=code&scope=snsapi_privateinfo&state=STATE#wechat_redirect`;
    }
  }
  }, [corpId, type]);

  return <></>;
}
